import { BASE_URL } from "./apiConst";

export const EXAM_FORM = `${BASE_URL}/exam/phd/create`;

export const GET_EXAM_FORM = `${BASE_URL}/exam/phd/getAll`;

export const GET_EXAM_FORM_BYId = `${BASE_URL}/exam/phd/getById`;

export const UPDATE_EXAM_FORM = `${BASE_URL}/exam/phd/update`;
